<template>
  <div class="modal fade" id="ispAddModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered w-[700px]">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">Add ISP</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="overflow-hidden">
            <div class="float-left w-1/2 px-5 h-20 modal-item">
              ISP Name:
              <v-text-field v-model="name" variant="outlined" density="compact"></v-text-field>
            </div>
            <div class="float-left w-1/2 px-5 h-20 modal-item">
              Country:
              <v-select v-model="country" :items="countries.map(c => c.name)" variant="outlined" density="compact"></v-select>
            </div>
            <div class="float-left w-full px-5 h-20 modal-item">
              Image:
              <v-file-input label="Choose an image" accept="image/*" variant="outlined" density="compact"
                @change="onFileChange"></v-file-input>
            </div>
            <div class="float-left w-full px-5 h-14 modal-item flex items-center">
              Sellable:
              <v-switch class="ml-4" v-model="sellable" color="success"></v-switch>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
          <button type="button" :disabled="buttonDisableFlag" class="btn btn-primary" @click="handleCreate">
            Create
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineEmits, defineProps, ref, watch } from "vue";
import { useAdminIspStore } from "@/stores";

const props = defineProps({
  countries: { type: Array, default: () => [] },
});
const emit = defineEmits(["created"]);

const adminIspStore = useAdminIspStore();

const buttonDisableFlag = ref(false);
const name = ref("");
const country = ref("");
const sellable = ref(true);
const file = ref(null);

watch(
  () => props.countries,
  (v) => {
    if (!country.value && v?.length) country.value = v[0].name;
  },
  { immediate: true }
);

const onFileChange = (event) => {
  const f = event?.target?.files?.[0];
  file.value = f || null;
};

const handleCreate = async () => {
  buttonDisableFlag.value = true;
  const formData = new FormData();
  formData.append("name", name.value);
  formData.append("country", country.value);
  formData.append("sellable", String(sellable.value));
  if (file.value) formData.append("file", file.value);

  await adminIspStore.createIsp(formData);
  buttonDisableFlag.value = false;
  name.value = "";
  sellable.value = true;
  file.value = null;
  emit("created");
};
</script>

